import styled from "styled-components";
import config from "../../../config";

export const SubInner = styled.div`
  @media ${config.layout.wide} {
    width: 100%;
    margin: 0 auto;
  }
`;

const TabHeaderArea = styled.div`
  padding-bottom: 10px;
  position: relative;
  left: -20px;
  width: calc(100% + 40px);
  @media ${config.layout.wide} {
    left: 0;
    width: 100%;
  }
`;
const TabHeaderButtons = styled.div`
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid #000000;
  @media ${config.layout.wide} {
  }
`;

const TabHeaderButton = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  text-align: center;
  height: 44px;
  position: relative;
  cursor: pointer;
  background-color: #ffffff;
  border-left: 1px solid #000000;

  &:first-child {
    border-left: none;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    background-color: #000000;
    transition: left 0.3s ease-out 0.1s;
  }

  &.disabled {
    cursor: default;
    border-left-color: #CDCDCD;

    &:first-child {
      border-left: none;
    }

    &::before {
      background-color: #CDCDCD;
    }
  }

  h3 {
    width: 100%;
    z-index: 1;
    font-size: 14px;
    line-height: 15px;
    font-weight: bold;
    color: #ffffff;
    transition: color 0.1s linear 0.1s;
  }

  &.not-selected {
    &:not(.disabled) {
      &:after {
        transition: background-position 0.15s ease-out;
      }
    }

    &:hover {
      &:not(.disabled) {
        h3 {
          color: #000000;
        }

        &::before {
          //background: #fff;
          //border-bottom: none;
          left: 100%;
          transition: left 0.3s ease-out;
        }

        &:after {
          transition: background-position 0.15s ease-in 0.15s;
          background-position: center -3px;
        }
      }
    }
  }

  &.selected {
    cursor: default;

    &::before {
      background: #fff;
      border-bottom: none;
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }

    h3 {
      color: #000000;
      mix-blend-mode: normal;
    }

    &::after {
      background-position: center -3px;
    }
  }


  &::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 10px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12"><g id="多角形_1" data-name="多角形 1" transform="translate(24 12) rotate(180)" fill="%23fff"><path d="M 22.79290008544922 11.5 L 1.207100033760071 11.5 L 12 0.707099974155426 L 22.79290008544922 11.5 Z" stroke="none"/><path d="M 12 1.414219856262207 L 2.414220809936523 11 L 21.58577919006348 11 L 12 1.414219856262207 M 12 0 L 24 12 L 0 12 L 12 0 Z" stroke="none" fill="%23000"/></g></svg>');
    background-repeat: no-repeat;
    background-size: 24px 12px;
    background-position: center -11px;
    left: 50%;
    bottom: -10px;
  }

`;

/**
 *
 * buttons: [
 *  {
 *    title: string,
 *    disabled: boolean (false),
 *  }
 * ],
 * selectedIndex: number,
 * onClickTab: function(selectedIndex){}
 */
export function TabHeader({
  buttons = [],
  selectedIndex = 0,
  onClickTab = null,
  ...props
}) {
  return (
      <TabHeaderArea {...props}>
        <TabHeaderButtons>
          {buttons.map((b, i) => {
            return (
                <TabHeaderButton
                    key={i}
                    className={`clickable ${b.disabled ? "disabled" : ""} ${
                        selectedIndex == i ? "selected" : "not-selected"
                    }`.trim()}
                    onClick={() => {
                      if (onClickTab && selectedIndex != i && !b.disabled) {
                        onClickTab(i);
                      }
                    }}
                    style={{
                      width: Math.floor((1 / buttons.length) * 10000) / 100 + "%",
                    }}
                >
                  <h3>{b.title}</h3>
                </TabHeaderButton>
            );
          })}
        </TabHeaderButtons>
      </TabHeaderArea>
  );
}

const SectionTitleWrap = styled.h3`
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
`;

export function SectionTitle({ children, ...props }) {
  return <SectionTitleWrap {...props}>{children}</SectionTitleWrap>;
}

const InputLabelElm = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 21px;
  font-weight: bold;
  i {
    color: #FF7323;
  }
`;

export function InputLabel({ required = false, children, ...props }) {
  return (
      <InputLabelElm {...props}>
        {children}
        {required ? <i>*</i> : ""}
      </InputLabelElm>
  );
}

const RequiredLabelElm = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  color: #000000;
  i {
    color: #FF7323;
    margin-right:0.2em;
    display: inline-block;
    font-style: normal;
  }
`;

export function RequiredLabel() {
  return (
      <RequiredLabelElm>
        Fields marked with <i>*</i> must be filled in
      </RequiredLabelElm>
  );
}

export const FormInput = styled.input`
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  display: block;
  width: 100%;
  height: 44px;
  padding: 0px 20px !important;
  background-color: #fff;
  border-radius: 2px;
  &::placeholder {
    color: #d9d9d9;
  }
  @media ${config.layout.wide} {
    font-size: 14px;
  }
`;

export const FormTextArea = styled.textarea`
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  display: block;
  width: 100%;
  height: 200px;
  padding: 20px !important;
  background-color: #fff;
  border-radius: 4px;
  &::placeholder {
    color: #d9d9d9;
  }
  @media ${config.layout.wide} {
    height: 300px;
    font-size: 14px;
  }
`;

export const AddMoreButton = styled.button`
  height: 44px;
  line-height: 43px;
  font-weight: bold;
  font-size: 14px;
  padding: 0 40px 0 16px;
  border-radius: 2px;
  position: relative;
  border-color: #000000;
  background-color: #ffffff;
  transition: background-color 0.15s linear, color 0.15s linear;

  &::before {
    content: "";
    display: block;
    width: 14px;
    height: 4px;
    position: absolute;
    right: 16px;
    background-color: #000000;
    top: 50%;
    margin-top: -2px;
    transition: background-color 0.15s linear, color 0.15s linear;
  }
  &::after {
    content: "";
    display: block;
    width: 4px;
    height: 14px;
    position: absolute;
    right: 21px;
    background-color: #000000;
    top: 50%;
    margin-top: -7px;
    transition: background-color 0.15s linear, color 0.15s linear;
  }
  @media ${config.layout.wide} {
    &:hover {
      color: #fff;
      border-color: #000000;
      background-color: #000000;

      &::before {
        background-color: #fff;
      }

      &::after {
        background-color: #fff;
      }
    }
  }
`;

export const RemoveItemButton = styled.button`
  flex: 0 0 auto;
  height: 36px;
  width: 36px;
  padding: 0;
  border-radius: 50%;
  position: relative;
  border-color: #000000;
  background-color: transparent;
  transition: background-color 0.15s linear, color 0.15s linear;

  &::before {
    content: "";
    display: block;
    width: 14px;
    height: 4px;
    position: absolute;
    left: 50%;
    margin-left: -7px;
    background-color: #000000;
    top: 50%;
    margin-top: -2px;
    transition: background-color 0.15s linear, color 0.15s linear;
  }

  &[disabled] {
    opacity: 0.3;
  }

  @media ${config.layout.wide} {
    &:hover {
      &:not([disabled]) {
        color: #fff;
        border-color: #000000;
        background-color: #000000;

        &::before {
          background-color: #fff;
        }
      }
    }
  }
`;

export const PageMainTitle = styled.h1`
  height: 80px;
  border-bottom: 6px solid #000000;
  position: relative;
  span {
    display: inline-block;
    width: 100%;
    font-weight: bold;
    font-size: 30px;
    line-height: 39px;
    margin-top: 20px;
  }
  @media ${config.layout.wide} {
    height: 100px;
    span {
      margin-top: 40px;
    }
  }
`;

export const PageSubTitle = styled.h2`
  height: 80px;
  border-bottom: 6px solid #000000;
  span {
    display: inline-block;
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    margin-top: 30px;
  }
  @media ${config.layout.wide} {
    height: 100px;
    span {
      margin-top: 50px;
    }
  }
`;
